import React, { useCallback, useState } from "react";
import { Box } from "@intech/web-ui";
import { IdPasso, ListaPassos0002, MontarListaPassosDisponiveis, Passo } from "@contexts";

import { Header } from "./Header";
import { MasterPage } from "@components";
import { NumFuncionalidade } from "@src/helpers/BloqueioFuncionalidade";
import { Passo1, Passo10, Passo2, Passo3, Passo4, Passo5, Passo6, Passo7, Passo8, Passo9, SituacaoRecad } from "./Passos";

export * from "./Passos";

export const Recadastramento: React.FC = (props) => {

  const [PassoAtual, setPassoAtual] = useState<Passo>(ListaPassos0002[0]);
  const [NumeroPassoAtual, setNumeroPassoAtual] = useState<number>(0);
  const [ListaPassosDisponiveis, setListaPassosDisponiveis] = useState<Passo[]>(ListaPassos0002);

  async function salvarListaPassosDisponiveis(parametros: number[], cdPlano: string) {
    const passos = MontarListaPassosDisponiveis(parametros, cdPlano);
    setListaPassosDisponiveis(passos);
  };

  async function avancar(PassoEspecifico?: number | null) {
    const ids = ListaPassosDisponiveis.map(x => x.ID);
    const idAtual = PassoEspecifico || PassoAtual.ID;
    const indexAtual = ids.indexOf(idAtual);
    const indexProximo = indexAtual + 1;
    const proximo = ListaPassosDisponiveis[indexProximo];

    setNumeroPassoAtual(NumeroPassoAtual + 1);
    setPassoAtual(proximo);
  };

  async function voltar(PassoEspecifico?: number | null) {
    const ids = ListaPassosDisponiveis.map(x => x.ID);
    const idAtual = PassoEspecifico || PassoAtual.ID;
    const indexAtual = ids.indexOf(idAtual);
    const indexAnterior = indexAtual - 1;
    const anterior = ListaPassosDisponiveis[indexAnterior];

    setNumeroPassoAtual(NumeroPassoAtual - 1);
    setPassoAtual(anterior);
  };

  async function reiniciar() {
    setNumeroPassoAtual(0);
    setPassoAtual(ListaPassos0002[0]);
  };

  const titulo = useCallback(() => {
    return (PassoAtual && PassoAtual.ID > 0) ? `Passo ${NumeroPassoAtual} - ${PassoAtual.TXT_TITULO}` : "";
  }, [NumeroPassoAtual, PassoAtual]);

  return (
    <MasterPage Funcionalidade={NumFuncionalidade.RECADASTRAMENTO} {...props}>
      <>
        <Header />

        <Box title={titulo()}>
          {PassoAtual && PassoAtual.ID === IdPasso.SituacaoRecad && <SituacaoRecad salvarListaPassosDisponiveis={salvarListaPassosDisponiveis} avancar={avancar} />}

          {PassoAtual && PassoAtual.ID === IdPasso.Passo1 && <Passo1 avancar={avancar} />}

          {PassoAtual && PassoAtual.ID === IdPasso.Passo2 && <Passo2 avancar={avancar} voltar={voltar} />}

          {PassoAtual && PassoAtual.ID === IdPasso.Passo3 && <Passo3 avancar={avancar} voltar={voltar} />}

          {PassoAtual && PassoAtual.ID === IdPasso.Passo4 && <Passo4 avancar={avancar} voltar={voltar} />}

          {PassoAtual && PassoAtual.ID === IdPasso.Passo5 && <Passo5 avancar={avancar} voltar={voltar} />}

          {PassoAtual && PassoAtual.ID === IdPasso.Passo6 && <Passo6 avancar={avancar} voltar={voltar} />}

          {PassoAtual && PassoAtual.ID === IdPasso.Passo7 && <Passo7 avancar={avancar} voltar={voltar} />}

          {PassoAtual && PassoAtual.ID === IdPasso.Passo8 && <Passo8 avancar={avancar} voltar={voltar} />}

          {PassoAtual && PassoAtual.ID === IdPasso.Passo9 && <Passo9 avancar={avancar} voltar={voltar} />}

          {PassoAtual && PassoAtual.ID === IdPasso.Passo10 && <Passo10 reiniciar={reiniciar} voltar={voltar} />}
        </Box>
      </>
    </MasterPage>
  );
}